module.exports = __webpack_public_path__ + "0068a76113cd4c5d6eca15146ddc8e04.png";